(() => {
  if (window.cartTermsConsentLoaded) return;
  window.cartTermsConsentLoaded = true;

  const selector = '[data-cart-terms-consent]';

  const update = (checkbox) => {
    const scope = checkbox.closest('[data-cart-terms-scope]');
    if (!scope) return;

    scope.querySelectorAll('[data-cart-terms-checkout]').forEach((button) => {
      button.disabled = !checkbox.checked;
    });
    scope.querySelectorAll('[data-cart-terms-accelerated]').forEach((container) => {
      container.hidden = !checkbox.checked;
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches(selector)) update(event.target);
  });

  document.addEventListener('submit', (event) => {
    const scope = event.target.closest('[data-cart-terms-scope]');
    const checkbox = scope?.querySelector(selector);
    if (checkbox && !checkbox.checked) event.preventDefault();
  });
})();
